// Static image imports for the sodistore home on-site installation checklist.
// Webpack/CRA resolves each import to a bundled URL string.

import step1Auspacken from './step1-auspacken.jpg';
import step2WrMontiert from './step2-wr-montiert.jpg';
import step2AcAnschluesse from './step2-ac-anschluesse.jpg';
import step2AcStecker from './step2-ac-stecker.jpg';
import step3Hauptverteilung from './step3-hauptverteilung.jpg';
import step3Hauptverteilung2 from './step3-hauptverteilung-2.jpg';
import step4Meter from './step4-meter.jpg';
import step4Wandler from './step4-wandler.jpg';
import step5Gateway from './step5-gateway.jpg';
import step6Batterien from './step6-batterien.jpg';
import step6Splitter from './step6-splitter.jpg';
import step7PvSwitch from './step7-pv-switch.jpg';
import step8BatterieBreaker from './step8-batterie-breaker.jpg';

export const ON_SITE_IMAGES: Readonly<Record<string, string>> = {
  'step1-auspacken.jpg': step1Auspacken,
  'step2-wr-montiert.jpg': step2WrMontiert,
  'step2-ac-anschluesse.jpg': step2AcAnschluesse,
  'step2-ac-stecker.jpg': step2AcStecker,
  'step3-hauptverteilung.jpg': step3Hauptverteilung,
  'step3-hauptverteilung-2.jpg': step3Hauptverteilung2,
  'step4-meter.jpg': step4Meter,
  'step4-wandler.jpg': step4Wandler,
  'step5-gateway.jpg': step5Gateway,
  'step6-batterien.jpg': step6Batterien,
  'step6-splitter.jpg': step6Splitter,
  'step7-pv-switch.jpg': step7PvSwitch,
  'step8-batterie-breaker.jpg': step8BatterieBreaker
};
